import Vue from 'vue'

import { useBreakpoints, breakpointsBootstrapV5 } from '@vueuse/core'
import VueLogger from 'vuejs-logger'
import store from '@/store'
import EventBus from '@/utils/event-bus'
import lodash from 'lodash-es'
import moment from 'moment-timezone'
import 'moment/locale/fr'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import {
  required,
  email,
  numeric,
  digits,
  min,
  regex,
} from 'vee-validate/dist/rules'
import 'bootstrap/js/dist/collapse'
/*
 *
 */
import '@/styles/index.scss'
import '@/icons' // icon
import FilterTrainings from '@/apps/archive-trainings/components/FilterTrainings.vue'
import Navbar from '@/components/partials/Navbar/index.vue'

/*
 *
 */
const isProduction = process.env.NODE_ENV === 'production'
/*
 *
 */
window.dataLayer = window.dataLayer || []
/*
 *
 */
const vueLoggerOptions = {
  isEnabled: true,
  logLevel: isProduction ? 'error' : 'debug',
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: '|',
  showConsoleColors: true,
}

Vue.use(VueLogger, vueLoggerOptions)
/*
 *
 */
Vue.component('Navbar', Navbar)
Vue.component('FilterTrainings', FilterTrainings)
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)

/*
 *
 */
extend('required', {
  ...required,
  message: 'Champ obligatoire ',
})
extend('email', {
  ...email,
  message: 'Adresse e-mail invalide',
})
extend('numeric', {
  ...numeric,
  message: 'le champ dois étre numérique',
})

extend('digits', {
  ...digits,
  message: '',
})
extend('min', {
  ...min,
  message: '',
})
extend('regex', {
  ...regex,
  message: '',
})
/*
 *
 */
Object.defineProperties(Vue.prototype, {
  $bus: {
    get() {
      return EventBus
    },
  },
})
Object.defineProperty(Vue.prototype, '$lodash', { value: lodash })
Object.defineProperty(Vue.prototype, '$moment', { value: moment })
/*
 *
 */

Vue.config.productionTip = false

function reducer(set1, set2) {
  return new Set([...set1].filter((x) => set2.has(x)))
}
document.addEventListener('DOMContentLoaded', () => {
  new Vue({
    el: '#app',
    store,
    setup() {
      const breakpoints = useBreakpoints(breakpointsBootstrapV5)
      const lgBreakpoint = breakpoints.greater('lg')
      return { lgBreakpoint }
    },
    data() {
      return {
        isLoaded: false,
        items: [],
        filter: {
          format: '',
          modalite: '',
          q: '',
          thematique: '',
          region: '',
          city: '',
        },
        encodedNoFilters: '',
      }
    },
    computed: {
      encodedFilters() {
        return !this.$lodash.isEmpty(this.filter)
          ? btoa(JSON.stringify(this.filter))
          : null
      },
    },
    created() {
      this.$store.commit('app/SET_API_BASEURL', process.env.VUE_APP_BASE_API)
    },
    mounted() {
      document.onreadystatechange = () => {
        if (document.readyState == 'complete') {
          this.isLoaded = true
        }
      }
      this.$bus.$on('handle.filter.reset', () => {
        const divs = document.querySelectorAll('[data-obj]')
        const divsThematiques = document.querySelectorAll('[data-thematique]')
        const noResult = document.querySelector('#no-result')
        if (noResult) {
          noResult.style.display = 'none'
        }
        divsThematiques.forEach((div) => {
          div.style.display = 'block'
        })
        divs.forEach((div) => {
          div.style.display = 'block'
        })
      })
      this.$bus.$on('handle.filter', (filter) => {
        this.filter = Object.assign({}, this.filter, filter)
        this.$nextTick(() => {
          const divs = document.querySelectorAll('[data-obj]')
          const divsThematiques = document.querySelectorAll('[data-region]')
          const categoryAccordions =
            document.querySelectorAll('[data-thematique]')
          const noResult = document.querySelector('#no-result')
          let matchKeywords = new Set()
          let matchThematique = new Set()
          let matchRegion = new Set()
          let matchCity = new Set()
          let matchParcours = new Set()
          let matchFormat = new Set()
          let matchModalite = new Set()
          let divsSet = new Set()
          let visibleCategories = new Set()
          let arrayOfSets = []
          let divsJsonList = Array.from(divs).map((item) => {
            return JSON.parse(item.getAttribute('data-obj'))
          })
          const q = this.filter?.q ?? ''

          let keywords = this.tokenize(q)
          const resSearch = divsJsonList.map((item) => {
            const index = keywords.findIndex((keyword) => {
              const name = item.name.toLowerCase()
              const ref = item.ref.toLowerCase()
              if (keyword.length > 3) {
                return (
                  name.includes(keyword.toLowerCase()) ||
                  ref.includes(keyword.toLowerCase())
                )
              } else return
            })
            if (index != -1) {
              return {
                ...item,
                includeSearchedItem: true,
              }
            } else return item
          })
          const result = resSearch.filter((item) => item.includeSearchedItem)
          divs.forEach((div) => {
            divsSet.add(div)
            const obj = JSON.parse(div.getAttribute('data-obj'))
            if (q.length > 2) {
              if (result && result.length) {
                result.forEach((item) => {
                  if (obj.ref == item.ref) matchKeywords.add(div)
                })
              }
              arrayOfSets.push(matchKeywords)
            }

            if (obj.categoryId && this.filter.thematique) {
              if (
                parseInt(this.filter.thematique) == parseInt(obj.categoryId)
              ) {
                matchThematique.add(div)
              }
              arrayOfSets.push(matchThematique)
            }

            if (obj.regions && this.filter.region) {
              for (let i = 0; i < obj.regions.length; i++) {
                if (
                  obj.regions[i]
                    .substr(0, this.filter.region.length)
                    .toUpperCase() == this.filter.region.toUpperCase()
                ) {
                  matchRegion.add(div)
                }
              }
              arrayOfSets.push(matchRegion)
            }
            if (obj.cities && this.filter.city) {
              for (let i = 0; i < obj.cities.length; i++) {
                if (
                  obj.cities[i]
                    .substr(0, this.filter.city.length)
                    .toUpperCase() == this.filter.city.toUpperCase()
                ) {
                  matchCity.add(div)
                }
              }
              arrayOfSets.push(matchCity)
            }
            if (obj.parcours && this.filter.parcours) {
              if (obj.parcours.includes(parseInt(this.filter.parcours))) {
                matchParcours.add(div)
              }
              arrayOfSets.push(matchParcours)
            }

            if (obj.modalite && this.filter.modalite) {
              if (parseInt(this.filter.modalite) == parseInt(obj.modalite)) {
                matchModalite.add(div)
              }
              arrayOfSets.push(matchModalite)
            }

            if (obj.format && this.filter.format) {
              console.log(this.filter.format)
              if (parseInt(this.filter.format) == parseInt(obj.format)) {
                matchFormat.add(div)
              }
              if (
                parseInt(this.filter.format) == 3 &&
                3 == parseInt(obj.format)
              ) {
                matchFormat.add(div)
              }
              arrayOfSets.push(matchFormat)
            }
          })
          let visibleDivs = new Set()

          //arrayOfSets = arrayOfSets.filter((s) => s.size)
          if (arrayOfSets.length) {
            visibleDivs = arrayOfSets.reduce(reducer)
          }

          let hiddenDivs = new Set(
            [...divsSet].filter((x) => !visibleDivs.has(x))
          )
          visibleDivs.forEach((div) => {
            div.style.display = 'block'
            const obj = JSON.parse(div.getAttribute('data-obj'))
            if (obj.categoryId) visibleCategories.add(parseInt(obj.categoryId))
          })
          hiddenDivs.forEach((div) => {
            div.style.display = 'none'
          })

          divsThematiques.forEach((div) => {
            if (
              visibleCategories.has(
                parseInt(div.getAttribute('data-thematique'))
              )
            ) {
              div.style.display = 'block'
            } else {
              div.style.display = 'none'
            }
          })
          if (visibleDivs.size) {
            noResult.style.display = 'none'
          } else {
            noResult.style.display = 'block'
          }
          if (categoryAccordions.length) {
            categoryAccordions.forEach((item) => {
              const cards =
                item.childNodes[0].children[1].children[0].children[0].children
              if ([...cards].length) {
                const itemsDisplayedBlock = [...cards].filter((i) => {
                  return i.style.display == 'block'
                })
                if (!itemsDisplayedBlock.length) {
                  item.style.display = 'none'
                } else item.style.display = 'block'
              }
            })
          }
        })
      })
      this.$store.dispatch('app/getCategories')
      this.$store.dispatch('app/getParcours')
      this.$store.dispatch('app/getRegions')
      this.$store.dispatch('app/getCities')
    },
    methods: {
      tokenize(text) {
        return text.split(/[\s,.!?;:([\]'"¡¿)/]+/).filter((x) => x)
      },
    },
  })
})
